import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import DatePicker from 'react-datepicker';
import './DateRangePickerWrapper.scss';

const propTypes = {
	onDatesChange: PropTypes.func.isRequired,
	autoFocus: PropTypes.bool,
	autoFocusEndDate: PropTypes.bool,
	initialStartDate: PropTypes.string, // Use string format (e.g., ISO) for dates
	initialEndDate: PropTypes.string,
	startDatePlaceholderText: PropTypes.string,
	endDatePlaceholderText: PropTypes.string,
	isOutsideRange: PropTypes.func,
	onDatePickerClick: PropTypes.func,
};

const defaultProps = {
	autoFocus: false,
	autoFocusEndDate: false,
	initialStartDate: null,
	initialEndDate: null,
	startDatePlaceholderText: 'Start Date',
	endDatePlaceholderText: 'End Date',
	isOutsideRange: () => false,
};

class DateRangePickerWrapper extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			startDate: props.initialStartDate ? this.parseDate(props.initialStartDate) : null,
			endDate: props.initialEndDate ? this.parseDate(props.initialEndDate) : null,
		};

		this.onDatesChange = this.onDatesChange.bind(this);
		this.onDatePickerClick = this.onDatePickerClick.bind(this);
	}

	parseDate = (dateString) => {
		return dateString ? new Date(dateString) : null;
	};

	formatDate = (date) => {
		return date ? format(date, 'yyyy-MM-dd') : null;
	};

	onDatesChange({ startDate, endDate }) {
		this.setState({
			startDate,
			endDate,
		});

		// Notify parent component
		this.props.onDatesChange(this.formatDate(startDate), this.formatDate(endDate));
	}

	onDatePickerClick() {
		this.props.onDatePickerClick();
	}

	render() {
		const { startDate, endDate } = this.state;
		const { startDatePlaceholderText, endDatePlaceholderText, isOutsideRange } = this.props;

		return (
			<div className="row">
				<div className={'col-6'}>
					<DatePicker
						selected={startDate}
						onChange={(date) => this.onDatesChange({ startDate: date, endDate })}
						selectsStart
						startDate={startDate}
						endDate={endDate}
						placeholderText={startDatePlaceholderText}
						filterDate={(date) => !isOutsideRange(date)}
						onFocus={this.onDatePickerClick}
					/>
				</div>
				<div className={'col-6'}>
					<DatePicker
						selected={endDate}
						onChange={(date) => this.onDatesChange({ startDate, endDate: date })}
						selectsEnd
						startDate={startDate}
						endDate={endDate}
						placeholderText={endDatePlaceholderText}
						filterDate={(date) => !isOutsideRange(date)}
						onFocus={this.onDatePickerClick}
					/>
				</div>
			</div>
		);
	}
}

DateRangePickerWrapper.propTypes = propTypes;
DateRangePickerWrapper.defaultProps = defaultProps;

export default DateRangePickerWrapper;
